module.exports = __webpack_public_path__ + "static/media/Step 10d-Medic.c656bb5f.png";